import * as _ from "lodash";
import * as React from "react";
import * as S from "@styled";
import { useHistory, useParams } from "react-router-dom";

import Select from "shared/components/select/Select";
import { Option } from "../../../shared/model/Option";
import { Utilities } from "../../../shared/utilities";
import { AppContext } from "../../App";
import { IRuleData } from "../../shared/model";
import CustomToggle from "shared/components/CustomToggle";
import { ChangeEvent, ClickEvent } from "shared/model/Event";

const RuleDeployment: React.FC<IRuleEditorDeploymentProps> = (props) => {

    const { state } = React.useContext(AppContext);
    const { environmentName } = useParams<{ environmentName: string }>();
    const history = useHistory();

    const [isActivated, setIsActivated] = React.useState<boolean>(true);
    const [targetEnvironment, setTargetEnvironment] = React.useState<Option>();
    const [newRuleName, setNewRuleName] = React.useState<string>();

    const selectOptions = state.environments.map((env) => { return { value: env.name, label: env.displayName } });

    const isNewRuleNameInvalid = _.isEmpty(newRuleName);
    const isValidDeployment = !isNewRuleNameInvalid && !_.isEmpty(targetEnvironment);

    const deployRule = async (e: ClickEvent<HTMLButtonElement>) => {
        e.preventDefault();
        if (!isValidDeployment) {
            Utilities.toastError("Invalid deployment. Check target Environment and new rule name.")
            return;
        }
        try {
            const deployToEnvironment = targetEnvironment?.value;
            await Utilities.postJsonAndParseResponse(`api/monitoringRules/deploy/${props.rule?.id}`, {
                environmentName: deployToEnvironment,
                isActivated,
                newRuleName
            })
            Utilities.toastSuccess("Successfully deployed rule");
            history.push(`${deployToEnvironment}/${deployToEnvironment}`)
        } catch (e) {
            Utilities.toastError(e);
            console.error(e);
        }
    }

    const handleChangeDeactivatedOnDeployment = () => setIsActivated(prev => !prev);
    const handleChangeTargetEnvironment = (env: Option) => setTargetEnvironment(env);
    const handleChangeNewRuleName = (newName: ChangeEvent<HTMLInputElement>) => setNewRuleName(newName.currentTarget.value);

    const options = selectOptions.filter((x) => x.value.toLowerCase() !== environmentName.toLowerCase());

    return (
        <S.FormGroup>
            <S.FormGroup>
                <S.Label htmlFor="environment">{FRENDS.Localizations.Deploy} to {FRENDS.Localizations.Environment}</S.Label>
                <Select
                    className="select-target-environment-selector"
                    isClearable={true}
                    classNamePrefix="react-select"
                    menuPlacement={"top"}
                    options={options}
                    value={Utilities.valueFromId(options, targetEnvironment?.value)}
                    onChange={handleChangeTargetEnvironment}
                    placeholder={"Select target Environment"}
                />
            </S.FormGroup>
            <S.FormGroup variant={newRuleName === "" ? S.FormGroupVariant.error : S.FormGroupVariant.primary}>
                <S.Label>New name</S.Label>
                <S.Input
                    className="new-rule-name-deployment-selector"
                    placeholder="New name for rule"
                    required={true}
                    onChange={handleChangeNewRuleName}
                    value={newRuleName}
                />
                {newRuleName === "" && <span className="error">New rule name required</span>}
            </S.FormGroup>
            <S.FormGroup>
                <S.Label>Activated on deployment</S.Label>
                <CustomToggle className="activate-on-deployment-selector" checked={isActivated} onChange={handleChangeDeactivatedOnDeployment} />
            </S.FormGroup>
            <S.Button onClick={deployRule} disabled={!isValidDeployment} id="deploy-rule">Deploy</S.Button>
        </S.FormGroup>
    );
};

interface IRuleEditorDeploymentProps {
    rule: IRuleData | undefined;
}

export default RuleDeployment;
